import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { CategoryDto, UpsertCategoryRequest } from '../lib/types';

export function useCategories() {
  return useQuery({
    queryKey: ['admin', 'categories'],
    queryFn: () => apiClient.get<CategoryDto[]>('/api/admin/categories'),
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: UpsertCategoryRequest) =>
      apiClient.post<CategoryDto>('/api/admin/categories', req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'categories'] }),
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, req }: { id: number; req: UpsertCategoryRequest }) =>
      apiClient.patch<CategoryDto>(`/api/admin/categories/${id}`, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'categories'] }),
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiClient.del<void>(`/api/admin/categories/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'categories'] }),
  });
}
